module.exports = __webpack_public_path__ + "img/Icon_call.9e42173e.svg";